import { Box, Button, IconButton, useTheme } from '@mui/material';
import { IoClose } from 'react-icons/io5';
import { IoIosImage } from 'react-icons/io';
import { PopupFooter, PopupHeader, TextOverflow, getCenterStyles } from 'vig-ui-library';

export type IdCardPreviewModalProps = {
    imageUrl: string;
    title: string;
    fileName: string;
    linkTokenHash: string;
    requestFileId: string;
    onClose: () => void;
};

export const IdCardPreviewModal = ({
    imageUrl,
    title,
    onClose,
}: IdCardPreviewModalProps) => {
    const theme = useTheme();

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                borderRadius: `${theme.shape.borderRadius}px`,
                overflow: 'hidden',
            }}
        >
            <PopupHeader sx={{ cursor: 'default' }}>
                <Box display="flex" alignItems="center" overflow="hidden" flexGrow={1} width="100%" gap={1}>
                    <Box display="flex" alignItems="center">
                        <IoIosImage size={24} color={theme.palette.primary.main} />
                    </Box>
                    <Box flexGrow={1} width="100%" overflow="hidden">
                        <TextOverflow text={title} variant="h6" lineHeight="24px" />
                    </Box>
                </Box>
                <Box display="flex" alignItems="center" flexShrink={0}>
                    <IconButton
                        sx={{ padding: '3px' }}
                        onClick={(e) => {
                            e.stopPropagation();
                            onClose();
                        }}
                        color="error"
                    >
                        <IoClose size={24} />
                    </IconButton>
                </Box>
            </PopupHeader>

            <Box sx={{ height: '70vh', overflowY: 'auto', ...getCenterStyles() }}>
                <Box
                    component="img"
                    src={imageUrl}
                    alt={title}
                    sx={{
                        maxWidth: '100%',
                        maxHeight: '100%',
                        objectFit: 'contain',
                    }}
                />
            </Box>

            <PopupFooter sx={{ borderTop: `1px solid ${theme.palette.divider}` }}>
                <Button
                    color="secondary"
                    onClick={(e) => {
                        e.stopPropagation();
                        onClose();
                    }}
                >
                    Zatvoriť
                </Button>
            </PopupFooter>
        </Box>
    );
};

